export default __webpack_public_path__ + "static/Image019_Settings-f43930cbee8d6c8bae4869a92c503c91.png";